var sliderCard = (function () {
    function e() {
        Array.from(document.querySelectorAll(".slider-card")).forEach(function (e) {
            var t = e.querySelector(".slider-card__card").offsetWidth,
                r = 0,
                n = 0;
            function a(e) {
                var t = e.closest(".slider-card").querySelector(".slider-card__container--active"),
                    r = t.querySelector(".slider-card__section"),
                    n = t.querySelector(".slider-card__card").offsetWidth,
                    a = r.children.length;
                window.innerWidth > 1023 && a * n <= r.offsetWidth
                    ? (e.closest(".labels").querySelector(".slider-card__navigation").classList.add("slider-card__navigation--hidden"),
                      e.closest(".labels").querySelector(".slider-card__section").classList.add("slider-card__section--centered"),
                      e.closest(".labels").querySelector(".multiple-media-wrapper-dots").classList.add("slider-card__navigation--hidden"))
                    : (e.closest(".labels").querySelector(".slider-card__navigation").classList.remove("slider-card__navigation--hidden"),
                      e.closest(".labels").querySelector(".slider-card__section").classList.remove("slider-card__section--centered"),
                      e.closest(".labels").querySelector(".multiple-media-wrapper-dots").classList.remove("slider-card__navigation--hidden"));
            }
            Array.from(e.querySelectorAll(".multiple-media-wrapper-dots > div")).forEach(function (e) {
                e.addEventListener("click", function (r) {
                    var n = parseFloat(e.dataset.cur),
                        a = 0 !== n ? 12 : 0;
                    (e.closest(".slider-card").querySelector(".slider-card__container--active").style.transform = "translateX(".concat(-1 * n * t * -1 - a, "px)")),
                        e.parentNode.children.forEach(function (e) {
                            e.classList.remove("active");
                        }),
                        e.classList.add("active");
                });
            }),
                Array.from(e.querySelectorAll(".slider-card__container")).forEach(function (e) {
                    var a = e.classList.contains("slider-card__swipe"),
                        i = a ? e.parentElement : e,
                        o = a ? e : i;
                    window.innerWidth < 1024 &&
                        (i.addEventListener("touchstart", function (e) {
                            e.stopImmediatePropagation(), (r = e.changedTouches[0].pageX);
                        }),
                        i.addEventListener("touchend", function (e) {
                            if ((e.stopImmediatePropagation(), (n = e.changedTouches[0].pageX), "touchend" === e.type)) {
                                var a = i.querySelector(".slider-card__card.active"),
                                    c = a ? parseFloat(a.dataset.cur) + 1 : "";
                                if (r > n) {
                                    if (!a.nextElementSibling) return;
                                    a.nextElementSibling.classList.add("active");
                                } else {
                                    if (!(r < n)) return;
                                    if (!a.previousElementSibling) return;
                                    c--, c--, a.previousElementSibling.classList.add("active");
                                }
                                (r > n || r < n) &&
                                    ((o.style.transform = "translateX(".concat(c * t * -1 - 12 * c, "px)")),
                                    a.classList.remove("active"),
                                    o.nextElementSibling && (o.nextElementSibling.querySelector(".active").classList.remove("active"), o.nextElementSibling.querySelectorAll("div")[c].classList.add("active")));
                            }
                        }));
                }),
                Array.from(e.querySelectorAll(".slider-card__nav")).forEach(function (e) {
                    a(e),
                        e.addEventListener("click", function (t) {
                            var r = e.classList.toString().includes("left") ? "left" : "right",
                                n = document.querySelector(".slider-card__container--active .slider-card__card").offsetWidth,
                                a = e.closest(".slider-card").querySelector(".slider-card__container--active"),
                                i = a.querySelector(".slider-card__section").children.length,
                                o = a.querySelector(".slider-card__card.active"),
                                c = a.querySelector(".slider-card__text"),
                                s = e.closest(".labels").querySelector(".label-container--active"),
                                l = s.querySelector(".dots .active"),
                                d = parseInt(o.dataset.cur),
                                u = Math.ceil(i / d),
                                v = s.querySelector(".slider-card__left"),
                                f = s.querySelector(".slider-card__right");
                            if ((window.innerWidth > 1023 && c && (i = u), "right" !== r || (v && v.classList.remove("slider-card__hidden"), d !== i - 3))) {
                                if ("left" === r) {
                                    if ((f && v.classList.remove("slider-card__hidden"), f && f.classList.remove("slider-card__hidden"), 0 === d)) return void (v && v.classList.add("slider-card__hidden"));
                                    window.innerWidth > 1023
                                        ? ((d -= 3), o.parentNode.querySelector('[data-cur="'.concat(d, '"]')).classList.add("active"), s.querySelector('.dots [data-cur="'.concat(d, '"]')).classList.add("active"))
                                        : (d--, o.previousElementSibling.classList.add("active"), l.previousElementSibling.classList.add("active"));
                                } else if (window.innerWidth > 1023) {
                                    if (d > i) return;
                                    (d += 3), o.parentNode.querySelector('[data-cur="'.concat(d, '"]')).classList.add("active"), s.querySelector('.dots [data-cur="'.concat(d, '"]')).classList.add("active");
                                } else {
                                    if (d >= i - 1) return;
                                    d++, o.nextElementSibling.classList.add("active"), l.nextElementSibling.classList.add("active");
                                }
                                o.classList.remove("active"), l.classList.remove("active"), (a.style.transform = "translateX(".concat(d * n, "px)"));
                            } else f && f.classList.add("slider-card__hidden");
                        });
                }),
                Array.from(document.querySelectorAll(".label")).forEach(function (e) {
                    e.addEventListener("click", function (e) {
                        var t = parseFloat(e.currentTarget.dataset.cur);
                        document.querySelectorAll(".label-container").forEach(function (e) {
                            e.classList.remove("label-container--active"), e.querySelector(".slider-card__container").classList.remove("slider-card__container--active");
                        }),
                            document.querySelectorAll(".label").forEach(function (e) {
                                e.classList.remove("label--active");
                            }),
                            document.querySelector('.label-container[data-cur="'.concat(t, '"]')).classList.add("label-container--active"),
                            document.querySelector('.label[data-cur="'.concat(t, '"]')).classList.add("label--active"),
                            document.querySelector('.label-container[data-cur="'.concat(t, '"]')).querySelector(".slider-card__container").classList.add("slider-card__container--active"),
                            a(document.querySelector('.label-container[data-cur="'.concat(t, '"]')).querySelector(".slider-card__container--active"));
                    });
                });
        });
    }
    "loading" !== document.readyState ? (window.addEventListener("resize", e), e()) : document.addEventListener("DOMContentLoaded", e);
})();